import { Reorder } from 'framer-motion';

import FantasticFanRow, { type FanRowColors } from './FantasticFans/FantasticFanRow';
import type { FantasticFanRowData } from './FantasticFans/types';

interface FantasticFansItemProps {
  fans: FantasticFanRowData[];
  colors?: FanRowColors;
  fontSize?: string;
  fontFamily?: string;
  isTrackModal?: boolean;
}

/**
 * Reorderable list of leaderboard bars. Expects a `Reorder.Group` ancestor —
 * see FantasticFans.tsx and analytics/FantasticFansTable.js.
 */
const FantasticFansItem = ({
  fans,
  colors,
  fontSize = '32px',
  fontFamily = 'Inter',
  isTrackModal = false,
}: FantasticFansItemProps) => (
  <div className="w-full inline-flex flex-col justify-start items-start gap-4">
    {fans.map((fan, index) => (
      <Reorder.Item
        as="div"
        key={fan.id || index}
        value={fan.id || index}
        className={`${isTrackModal ? 'w-[896px] mx-auto' : 'w-full'}`}
        layout
        transition={{ type: 'spring', stiffness: 40, damping: 20 }}
      >
        <FantasticFanRow
          fan={fan}
          index={index}
          colors={colors}
          fontFamily={fontFamily}
          fontSize={fontSize}
          size={isTrackModal ? 'compact' : 'full'}
        />
      </Reorder.Item>
    ))}
  </div>
);

export default FantasticFansItem;
